import React from 'react';
import Image from 'next/image';
import styles from './index.module.less';

const SuccessStories = ({ data }: { data: any }) => {
  return (
    <section className={styles.container}>
      <h2 className={styles.title}>{data.contentInfo['section-testimonial'].title}</h2>
      <div className={styles.scrollContainer}>
        <div className={styles.testimonials}>
          {data.contentInfo['section-testimonial'].cards.map((testimonial: any, index: number) => (
            <div key={index} className={styles.card}>
              <p className={styles.quote}>{testimonial.desc}</p>
              <div className={styles.author}>
                <Image
                  src={testimonial.imgPath}
                  alt={testimonial.desc}
                  width={40}
                  height={40}
                  className={styles.avatar}
                  loading="lazy"
                />
                <div className={styles.authorInfo}>
                  <p className={styles.name}>{testimonial.title}</p>
                  <p className={styles.role}>{testimonial.subTitle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuccessStories;
